export enum UserReferralCodeTypeEnum {
  UNUSED = 'unused',
}
